<template>
	<div>
		<vxe-modal v-model="modal_model" title="跟单二维码生成器" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close :loading="loading">
			<template #default>
				<el-input placeholder="单据编码XD" v-model="inputcode" class="input-with-select">
					<el-button slot="append"  @click="createma">点击生成跟单码</el-button>
				</el-input>
				<el-divider content-position="center" >二维码</el-divider>
				<div v-if="ma">
					<div class="flex" style="flex-direction: column;align-items: center;justify-content: center;">						
						<div class="flex" style="width: 250px;flex-direction: column;align-items: center;justify-content: center;box-sizing: border-box;padding: 10px;" ref="printContent">
							<h1 style="font-weight: bolder;">纳智跟单码</h1>
							<vue-qr style="position: relative;width: 200px;height: 200px;margin-bottom: 10px;" v-if="ma" class="ma" :text="ma"
								:size="1000" :margin="10"></vue-qr>
							<div style="font-size: 16px;font-weight: bolder;">
								<div style="text-align: center;">{{ordercode}}</div>
								<div>销售组长：15990727260</div>
								<div>销售主管：15057540431</div>
<!-- 								<div>销售经理：15869629958</div> -->
							</div>
						</div>
					</div>
				</div>
				
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="promary" content="下载" @click="download"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import vueQr from 'vue-qr'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import html2canvas from 'html2canvas';
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: 'title',
				modal_width: 600,
				modal_height: 600,
				loading:false,
				inputcode:'',
				ordercode:'',
				ma:''
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			createma(){				
				if(this.inputcode){
					this.ordercode = this.inputcode
					this.ma = 'https://wz-nazhi.com/H5/ordertrack/#/home?company='+window.config.company+'&ma=' + this.ordercode					
				}else{
					this.$message.error('单据编码不能为空')
				}
				
			},
			download() {
				if(this.inputcode){
					html2canvas(this.$refs.printContent).then((canvas) => {
						this.convertCanvasToImg(canvas)
					})
				}else{
					this.$message.error('请生先成二维码')
				}

			},
			convertCanvasToImg(canvas) {
				let myBlob = this.dataURLtoBlob(canvas.toDataURL('img/png', 1))
				let myUrl = URL.createObjectURL(myBlob)
				this.downImg(myUrl)
			},
			dataURLtoBlob(dataurl) {
				let arr = dataurl.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {
					type: mime
				});
			},
			downImg(url) {
				let a = document.createElement("a")
				let clickEvent = document.createEvent("MouseEvents")
				a.setAttribute("href", url)
				a.setAttribute("download", "报价单")
				a.setAttribute("target", '_blank')
				clickEvent.initEvent('click', true, true)
				a.dispatchEvent(clickEvent)
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			},
			modal_cancel() {
				this.inputcode = ''
				this.ordercode = ''
				this.ma = ''
				this.modal_model = false
			},
		},
		components: {
			vueQr
		}
	}
</script>